// filepath: apps/web/src/features/admin/hmacKeys/errorMessage.ts
//
// FR-UI-ADM-7 -- typed error message helper.
//
// Maps an error code (set by queries.ts on mutations) to a localized
// error message via the i18n t() function. Falls back to the err.message
// (the raw server error) when no code matches.

import type { TFunction } from "i18next";

export function errorApiToMessage(err: unknown, t: TFunction): string {
  if (err && typeof err === "object" && "code" in err) {
    const code = (err as { code: string }).code;
    if (code === "invalid_grace_window") {
      return t("admin.webhooks.keys.errors.invalid_grace_window");
    }
    if (code === "staging_only_forbidden") {
      return t("admin.webhooks.keys.errors.staging_only");
    }
  }
  if (err instanceof Error) {
    return err.message;
  }
  return String(err);
}
